import type { ServiceHandler } from "./storageHandlers";
import {
  clearMessages,
  clearSchemasState,
  setRefreshToken,
  setSchemaValue,
} from "../../../../../features/Schemas/redux/slice";
import { SchemasValue } from "../../../../api/instances/schemasApi/types";
import { getSchemaMessagesAction } from "../../../../../features/Schemas/redux/actions";
import { deleteThreadWithProxy } from "../../../../api/instances/responseApi/api";

export const SchemasService: ServiceHandler = {
  async onSelect(listenerApi, id, value, selectedId) {
    if (id === null || value === null) return;
    listenerApi.dispatch(setSchemaValue(value as SchemasValue));
    listenerApi.dispatch(clearMessages(id));

    if (selectedId === id) {
      listenerApi.dispatch(setRefreshToken());
    }

    const { thread_ref, mode } = (value as SchemasValue).metadata;
    if (thread_ref && mode === "generate_schema") {
      listenerApi.dispatch(
        getSchemaMessagesAction({ threadRef: thread_ref, id }),
      );
    }
  },
  async onDelete(listenerApi, id, value) {
    if (id === null || value === null) return;
    try {
      const { thread_ref } = (value as SchemasValue)?.metadata;
      if (thread_ref) {
        await deleteThreadWithProxy(thread_ref);
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
  async onLeave(listenerApi) {
    listenerApi.dispatch(clearSchemasState());
  },
};
